(function () {
  'use strict';
  angular.module('imnApp').factory('RelatorioService', RelatorioService);

  RelatorioService.$inject = ['$http', 'RequestService'];

  function RelatorioService($http, RequestService) {
    return {
      informacoesRelatorioDaOlt: informacoesRelatorioDaOlt,
      sincronizacaoForcada: sincronizacaoForcada
    };

    function informacoesRelatorioDaOlt(olt) {
      return $http.get(syncReportApi(olt.id)).then(responseData);
    }

    function sincronizacaoForcada(olt) {
      return $http.put(syncReportApi(olt.id));
    }

    function responseData(response) {
      return response.data;
    }

    function syncReportApi(method) {
      return RequestService.apiUrl('syncreport', method);
    }
  }
})();
